
import CreateBrand from './CreateBrand';
import EditBrand from './EditBrand';
import EditBrandBranding from './EditBrandBranding';
import EditBrandAdvancedOptions from './EditBrandAdvancedOptions';
import ListBrands from './ListBrands';
import ViewBrand from './ViewBrand';

export default { CreateBrand, EditBrand, ListBrands, ViewBrand, EditBrandBranding, EditBrandAdvancedOptions };



// WEBPACK FOOTER //
// ./src/components/pages/admin/brands/index.js